/**
 * confirm.js — 送信前の確認ダイアログ (旧: 各ページのインライン jQuery)
 *
 * マークアップ契約: <form data-confirm="本当に削除しますか？"> ... </form>
 * キャプチャフェーズで submit を捕捉し、キャンセルされたら送信を止める。
 */
export function initConfirm() {
  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target.closest('[data-confirm]');
      if (form && !window.confirm(form.getAttribute('data-confirm'))) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
}
